module.exports = __webpack_public_path__ + "media/categories/1022-e98777ef.svg";